<template>
  <index-content :breadcrumb-items="breadcrumbItems">
    <template #options>
      <div class="n-button-box">
        <nb-add @on-click="openModal" />
      </div>
    </template>
    <div class="table-responsive">
      <table class="table table-bordered table-hover table-striped text-center n-table">
        <colgroup>
          <col class="id" />
          <col class="from" />
          <col class="to" />
          <col class="login" />
          <col class="trading" />
          <col class="editing" />
          <col class="transfer" />
          <col v-rw class="action-remove" />
        </colgroup>
        <thead>
          <tr>
            <th rowspan="2">{{ $t('label.id') }}</th>
            <th rowspan="2">{{ $t('label.from') }}</th>
            <th rowspan="2">{{ $t('label.to') }}</th>
            <th colspan="4">{{ $t('label.restriction') }}</th>
            <th v-rw rowspan="2">{{ $t('label.action') }}</th>
          </tr>
          <tr>
            <th class="login">{{ $t('label.login') }}</th>
            <th class="trading">{{ $t('label.trading') }}</th>
            <th class="editing">{{ $t('label.editing') }}</th>
            <th class="transfer">{{ $t('label.transfer') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in records" :key="row.id">
            <td>{{ row.id }}</td>
            <td>{{ row.time1 | datetime }}</td>
            <td>{{ row.time2 | datetime }}</td>
            <td v-enums:LoginRestriction="row.loginRestriction"></td>
            <td v-enums:TradingRestriction="row.tradingRestriction"></td>
            <td v-enums:EditingRestriction="row.editingRestriction"></td>
            <td v-enums:TransferRestriction="row.transferRestriction"></td>
            <td v-rw class="n-button-box">
              <nb-confirm text="remove" @on-ok="doRemove(row)"></nb-confirm>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </index-content>
</template>

<script>
import BaseCompanyView from './view';
import { getSelection } from '@/store';
import ModalCompanyHoliday from './ModalCompanyHoliday';
import { fetch, remove } from '@/api/company/company-holiday';

export default BaseCompanyView.extend({
  name: 'CompanyCompanyHoliday',

  data() {
    return {
      preload: true,
    };
  },

  mounted() {
    this.companyId = +this.$route.params.companyId;
    let companyName = getSelection('company.company', this.companyId);
    this.breadcrumbItems = [companyName, this.$t(`label.holidays`)];
  },

  methods: {
    doLoad() {
      let companyId = this.companyId;
      return fetch({ companyId });
    },

    doRemove(o) {
      return remove(o);
    },

    openModal(model = { companyId: this.companyId }) {
      this.createModal(ModalCompanyHoliday, { model, props: { subName: 'holiday' }, on: this });
    },

    parse(r) {
      this.records = r;
    },
  },
});
</script>
